import { Box, Button } from '@mui/material';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { SKILLX_DEPARTMENT_ID } from '../../../../utils/constants/GlobalStaticData';

const RedirectToCart = (params) => {
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const navigate = useNavigate();
  const handleNavigate = (id) => {
    if (id === 0) {
      navigate(`/my-workspace/cart`, {
        state: params,
      });
    } else {
      navigate(`/my-workspace/cart-skillx`, {
        state: params,
      });
    }
  };
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
      {profile?.departmentId === SKILLX_DEPARTMENT_ID ? (
        <Button
          size="small"
          onClick={() => handleNavigate(1)}
          sx={{
            color: 'white',
            background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
            borderRadius: 3,
          }}
        >
          <Icon icon="mdi:cart-outline" height={22} width={22} />
          Pick My Courses-SkillX
        </Button>
      ) : (
        <Button
          size="small"
          onClick={() => handleNavigate(0)}
          sx={{
            color: 'white',
            background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
            borderRadius: 3,
          }}
        >
          <Icon icon="mdi:cart-outline" height={22} width={22} />
          Pick My Courses
        </Button>
      )}
    </Box>
  );
};

export default RedirectToCart;
